module.exports = __webpack_public_path__ + "img/p16.cb43e562.png";